<template>
  <button @click="onClick" class="button" :class="[className]">
    <slot>Default Content</slot>
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    label: String,
    className: String
  },
  methods: {
    onClick(e) {
      this.$emit("onClick", e);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/styles/_variables.scss";
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(
    circle,
    rgba(253, 0, 38, 1) 0%,
    rgba(230, 0, 16, 1) 100%
  );
  border: none;
  width: 180px;
  height: 48px;
  box-shadow: 0px 9px 10px 2px $accentShadow;
  font-size: 18px;
  border-radius: 7px;
  text-align: center;
  font-weight: 400;
  cursor: pointer;
  color: #ffffff;

  &:active,
  &:hover,
  &:focus {
    background: $accentFocus;
    border-collapse: $accentFocus;
  }

  &:disabled {
    background: $defaultFocus;
    box-shadow: none;
    cursor: not-allowed;
  }

  &:hover:disabled {
    background: $defaultFocus;
  }

  @media screen and (max-width: $MobileMaxWidth) {
    width: 180px;
    height: 40px;
    font-size: 24px;
  }
}
</style>
